// Mappe l'etat /api/me sur l'ecran de porte (null = acces OK).
//
// CE VERDICT EST UN CONFORT D'AFFICHAGE, JAMAIS UNE GARDE. Il sert a ne pas
// peindre un shell qu'on va retirer une seconde plus tard. L'AUTORITE RESTE LE
// SERVEUR : GET /api/me porte requireAuth, et c'est le 403 HUB_USER_NOT_PROVISIONED
// (remap local, pas le 401 USER_NOT_PROVISIONED de la factory) qui protege.
// Un 401 declencherait en boucle le forceRefresh de @gs/api-client
// (packages/api-client/src/apiFetch.ts — retry uniquement si status === 401).
//
// Le hub n'a PAS de bounded context : pas d'etage entitlement ni de role.
// Seul `notProvisioned` est un refus. Toute autre erreur de /api/me est
// `unverifiable` — l'ecran informe et propose de reessayer (classifyMeAccessError
// dans @gs/api-client). On n'ouvre plus l'app en silence.
//
// ADR-076 D3 (2026-09-14) — UN CAS DE PLUS, ET CE N'EST PAS UNE ERREUR :
// /api/me repond 200 et dit `hasAnyAccess: false`. L'identite est legitime, elle
// n'a simplement aucun role encore attribue. On rend `accessPending` : la
// coquille qui ACCUEILLE. L'ordre compte — une erreur se classe AVANT, sinon un
// `data` absent (donc `hasAnyAccess` indefini) ferait passer un refus pour un
// accueil. Et l'accueil ne se declenche QUE sur un `false` explicite : un serveur
// plus ancien, qui ne connait pas encore le champ, garde le comportement d'avant
// plutot que d'enfermer tout le monde dans la coquille.

import { classifyMeAccessError } from '@gs/api-client';
import type { AccessGateKind } from '@gs/ui';

export const HUB_USER_NOT_PROVISIONED = 'HUB_USER_NOT_PROVISIONED';

export function resolveAccessGate(me: {
  isError: boolean;
  error: unknown;
  data?: { hasAnyAccess?: boolean } | undefined;
}): AccessGateKind | null {
  if (me.isError) return classifyMeAccessError(me.error, HUB_USER_NOT_PROVISIONED);
  if (me.data?.hasAnyAccess === false) return 'accessPending';
  return null;
}
